<a [routerLink]="['/noticias', noticia?.idVideo, noticia?.tituloSeo | kebabCase]">
  <article class="noticia">
    <app-skeleton-image [created]="noticia?.fechaCreacion" [size]="size" [src]="noticia?.urlGenerica" [lazy]="idStart > 3" [alt]="noticia?.tituloVideo"></app-skeleton-image>
    <div class="cuerpo-noticia">
      <div class="header-article" [routerLink]="['/noticias', noticia?.idVideo, noticia?.tituloVideo | kebabCase]" [title]="noticia?.tituloVideo">{{ noticia?.tituloVideo }}</div>
      <div class="footer-article">
        <ng-container *ngFor="let tag of noticia?.tags | slice: 0 : 2; trackBy: trackByTag">
          <span class="tag-noticia" [routerLink]="['/tag', $any(tag) | kebabCase]">{{ tag }} <span class="separador"> | </span></span>
        </ng-container>
      </div>
    </div>
  </article>
</a>
